import { render, staticRenderFns } from "./Treaty.vue?vue&type=template&id=2f5c9025&scoped=true"
import script from "./Treaty.vue?vue&type=script&lang=js"
export * from "./Treaty.vue?vue&type=script&lang=js"
import style0 from "./Treaty.vue?vue&type=style&index=0&id=2f5c9025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c9025",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VDivider,VSkeletonLoader})
